<template>
  <b-modal
    v-bind:visible="visible"
    v-bind:title="title"
    v-bind:no-close-on-backdrop="mNoClose"
    v-bind:hide-header-close="mNoClose"
    v-bind:no-close-on-esc="mNoClose"
    v-bind:no-enforce-focus="mNoClose"
    :size="size"
    centered
    ok-only
    ok-variant="primary"
    @ok="emitOk"
    @hidden="updateVmodel"
  >
    <template v-slot:modal-footer="{ ok, cancel }">
      <slot name="leftOfButton"></slot>
      <b-button variant="secondary" @click="cancel()">{{
        negativeText
      }}</b-button>
      <b-button variant="primary" @click="ok()">{{ postiveText }}</b-button>
    </template>
    <p class="mb-2">
      <slot></slot>
    </p>
  </b-modal>
</template>

<script>
export default {
  name: "DialogYesNo",
  props: {
    title: {
      default: "Info"
    },
    // to user the noClose prop, set it to a truthy value and then use ev.preventDefault on the 'ok' event to prevent closing
    noClose: {
      default: false
    },
    visible: {
      default: false
    },
    negativeText: {
      default: "Cancel"
    },
    postiveText: {
      default: "OK"
    },
    size: {
      default: ""
    }
  },
  model: {
    prop: "visible",
    event: "hidden"
  },
  computed: {
    mNoClose() {
      return this.noClose == true;
    }
  },
  methods: {
    updateVmodel() {
      this.$emit("hidden", false);
    },
    emitOk(ev) {
      this.$emit("ok", ev);
    }
  }
};
</script>
